/*
var odds = calculateParlayOdds(arrayOfOdds);
var payout = calculatePayout(10, odds);
var profit = calculateProfit(10, payout);
*/

export const calculatePayout = (wager: number, odds: number) => {
    return wager * odds;
}

export const calculateProfit = (wager: number, payout: number) => {
    return payout - wager;
}

export const calculateParlayOdds = (arrayOfOdds: any, selectedBets: number[]) => {
    let parlayOdds = 1;
    if (selectedBets.length > 0) {
        arrayOfOdds.map((items: any, index: number) => {
            if (selectedBets[index] !== null && selectedBets[index] !== -1) {
                parlayOdds *= items.selectedBet?.oddsDecimal;
            }
        })
    }

    return parlayOdds;
}

export const calculateTotalWager = (arrayWage: string[]) => {
    let sum = 0;
    arrayWage.map((item) => {
        const wager = item && item !== 'invalid' ? Number(item.replace('$', '')) : 0
        sum += wager
    });
    return sum;
}

export const getTotalToWin = (odds: number, wg: string) => {
    const wager = wg ? Number(wg.replace('$', '')) : 0
    const payout = calculatePayout(wager, odds);

    return calculateProfit(wager, payout)
}